module.exports = __webpack_public_path__ + "static/media/islamabad.1db4c56c.svg";